import { create } from 'zustand';
import type { PublicSiteConfig } from '@/features/site-config/api.js';

interface BrandingState {
  branding: PublicSiteConfig | null;
  setBranding: (b: PublicSiteConfig | null) => void;
}

export const useBrandingStore = create<BrandingState>((set) => ({
  branding: null,
  setBranding: (branding) => set({ branding }),
}));
